export const APP_STORAGE_NAMESPACE = 'minimany'
export const APP_DATABASE_NAME = APP_STORAGE_NAMESPACE
export const DEVICE_STORAGE_KEY = `${APP_STORAGE_NAMESPACE}:device:v1`
export const AUTH_DATABASE_NAME = `${APP_STORAGE_NAMESPACE}-auth`
export const AUTH_STORAGE_PREFIX = AUTH_DATABASE_NAME

// Kept only as encoded migration input so upgrades can discover and move data
// written before the miniMany rename without retaining the retired brand text.
const PREVIOUS_BRAND_CODE_POINTS = [113, 113, 110, 111, 116, 101] as const

export function previousBrandStorageName(): string {
  return String.fromCodePoint(...PREVIOUS_BRAND_CODE_POINTS)
}
